export const MEMPOOL_SPACE_API_V1_URL = 'https://mempool.space/api/v1'
export const COINCAP_WEBSOCKET_URL = 'wss://ws.coincap.io/prices?assets=bitcoin'
export const QRSNAP_BASE_URL = 'https://tcc.qrsnap.io'
export const TCADMIN_API_URL = 'https://admin.timechaincalendar.com/wp-json/wp/v2'
export const BITNODES_API_URL = 'https://bitnodes.io/api/v1/snapshots/'
export const TIMECHAININDEX_API_URL = 'https://timechainindex.com/api'

export const TIMECHAIN_CALENDAR_DATA_URL = 'https://data.timechaincalendar.com'
export const TIMECHAIN_CALENDAR_API_URL = 'https://api.timechaincalendar.com'
export const TIMECHAIN_CALENDAR_PRICE_FEED_URL = 'wss://exchange.timechaincalendar.com/feed/v1'
export const TIMECHAIN_CALENDAR_PRICE_REST_URL = 'https://exchange.timechaincalendar.com/rest/v1'
export const TIMECHAIN_CALENDAR_STATIC1_URL = 'https://static1.timechaincalendar.com'
export const TCD_PRICE_API_URL = 'wss://exchange.timechaincalendar.com/feed/v1'
